module.exports = __webpack_public_path__ + "static/media/testimony3.973f9852.png";